import axios from '../../../build/http-requests/axios-common'

export default {
  state: {

  },

  mutations: {
  },

  actions: {
    getStates: ({ commit }) => {
      return new Promise((resolve, reject) => {
        axios.get('/states')
          .then(response => {
            resolve(response.data.data)
          }).catch((error) => {
            reject(error)
          })
      })
    }
  },

  getters: {
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/states.js